// extracted by mini-css-extract-plugin
export default {"type_box":"style_type_box__J+JKn"};